import {Component} from '@angular/core';
import {MatCard, MatCardContent} from '@angular/material/card';

@Component({
  selector: 'tgrid-verify-email',
  imports: [
    MatCard,
    MatCardContent,
  ],
  template: `
    <mat-card>
      <mat-card-content>
        <span>Your email has been verified, and your account request has been forwarded to the site admin for approval!</span>
      </mat-card-content>
    </mat-card>
  `,
  standalone: true,
  styles: `
    :host {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;

      //noinspection CssUnknownTarget
      background-image: url("/dist/angulario/browser/src/assets/images/login_bg_small.jpg");
      background-repeat: repeat;
    }


    mat-card {
      position: absolute;
      top: 50%;
      left: 10%;
      padding: 20px;
      transform: translateY(-50%);
      width: 400px;
      color: forestgreen;
    }
  `,
})
export class VerifyEmailComponent {

}
